package com.bikompanion.ui.strings

val RuBikompanionStrings = object : BikompanionStrings {
    override val actionRetry = "Повторить"
    override val actionClose = "Закрыть"
    override val actionSubmit = "Отправить"
    override val detailsLabel = "Подробности"
    override val detailsShow = "Показать подробности"
    override val detailsHide = "Скрыть подробности"
    override val actionGetDirections = "Маршрут"
    override val actionShareStation = "Поделиться станцией"
    override val linkCopied = "Ссылка скопирована"
    override val locateShow = "Показать моё местоположение"
    override val locateFollowHeading = "Следовать по направлению"
    override val locateStopFollowing = "Перестать следовать за мной"
    override val settingsTitle = "Настройки"
    override val actionBack = "Назад"
    override val settingsAppearance = "Оформление"
    override val settingsLanguage = "Язык"
    override val languageSystem = "Как в системе"
    override val themeSystem = "Системная"
    override val themeLight = "Светлая"
    override val themeDark = "Тёмная"
    override val settingsNotifications = "Уведомления"
    override val stationAlerts = "Оповещения о станциях"
    override val notificationsOn = "Вкл.: сообщим, когда на отслеживаемой станции появится велосипед"
    override val notificationsOff = "Выкл.: отслеживаемые станции не смогут вас оповестить"
    override val notificationsBlocked = "Заблокировано: разрешите уведомления в настройках сайта в браузере"
    override val actionManage = "Управление"
    override val actionTurnOn = "Включить"
    override val settingsSupport = "Поддержка"
    override val sendFeedback = "Отправить отзыв"
    override val sendFeedbackDescription = "Расскажите о проблеме или неверных данных станции"
    override val shareApp = "Поделиться приложением"
    override val settingsAbout = "О приложении"
    override val aboutApp = "О Bikompanion"
    override val aboutDevelopedBy = "Разработчик: Tiago Araujo"
    override val aboutDataSources = "Источники данных"
    override val sourceCityBikesDescription = "Сети велопроката по всему миру"
    override val sourceGbfsTitle = "GBFS-каналы операторов"
    override val sourceGbfsDescription = "Данные станций в реальном времени от операторов велопроката"
    override val sourceOsmTitle = "Участники OpenStreetMap"
    override val sourceOsmDescription = "Велопарковки и картографические данные"
    override val sourceCartoDescription = "Тайлы карты"
    override val aboutLegal = "Правовая информация"
    override val licensesTitle = "Лицензии открытого ПО"
    override val privacyPolicy = "Политика конфиденциальности"
    override val deleteRatings = "Удалить мои оценки"
    override val deleteRatingsDescription = "Отправляет нам ваш анонимный идентификатор, чтобы мы их удалили"
    override val licensesLoadFailed = "Не удалось загрузить список лицензий"
    override val aboutVersion = { version: String -> "Версия $version" }
    override val issueFlatTire = "Спущено колесо"
    override val issueFrontBrake = "Не работает передний тормоз"
    override val issueRearBrake = "Не работает задний тормоз"
    override val issueChain = "Соскакивает цепь"
    override val issueGears = "Не переключаются передачи"
    override val issueSeat = "Сиденье повреждено или отсутствует"
    override val issueLights = "Не работает освещение"
    override val issueLockOrBasket = "Повреждён замок или корзина"
    override val issueFrame = "Повреждена рама"
    override val issueMotor = "Не работает электромотор"
    override val issueBattery = "Аккумулятор не заряжается"
    override val issueOther = "Другое"
    override val networksLoadFailed = "Не удалось загрузить сети велопроката. Проверьте подключение."
    override val parkingLoadFailed = "Не удалось загрузить велопарковки"
    override val parkingLoading = "Поиск велопарковок…"
    override val stationsLoading = "Загрузка станций…"
    override val noNetworkHereTitle = "Здесь нет велопроката"
    override val noNetworkHereHint = "Отдалите карту, чтобы найти ближайшую сеть"
    override val installTitle = "Установите Bikompanion"
    override val installHintIos = "Нажмите «Поделиться», затем «На экран Домой»."
    override val installHintAndroid = "Скачайте приложение в Google Play."
    override val actionInstall = "Установить"
    override val parkingTypeStands = "Велостойки"
    override val parkingTypeShed = "Велонавес"
    override val parkingTypeLockers = "Велоячейки"
    override val parkingTypeBuilding = "Велопарковка в здании"
    override val parkingTypeOther = "Велопарковка"
    override val fieldAddress = "Адрес"
    override val fieldCovered = "Крытая"
    override val fieldYes = "Да"
    override val fieldNo = "Нет"
    override val fieldId = "ID"
    override val fieldStationId = "ID станции"
    override val fieldCoordinates = "Координаты"
    override val fieldCapacity = "Вместимость"
    override val fieldNetwork = "Сеть"
    override val fieldName = "Название"
    override val fieldCity = "Город"
    override val fieldCountry = "Страна"
    override val fieldCompany = "Компания"
    override val fieldLicense = "Лицензия"
    override val fieldLicenseUrl = "URL лицензии"
    override val availabilityBikes = "Велосипеды"
    override val availabilityElectric = "Электро"
    override val availabilityEmpty = "Свободно"
    override val bicingNextPickup = { p0: String -> "Следующий Bicing через $p0" }
    override val rateTitle = "Проверить или оценить велосипед"
    override val rateFindingNetworks = "Ищем сети велопроката рядом с вами…"
    override val rateWhatsWrong = "Что с ним не так?"
    override val rateBikeNumber = "Номер велосипеда"
    override val rateElectricBike = "Электровелосипед"
    override val rateVoteBad = "Плохо"
    override val rateVoteGood = "Хорошо"
    override val rateWhichNetwork = "Из какой сети этот велосипед?"
    override val refreshRateLimited = "Достигнут лимит запросов — повторяем автоматически"
    override val refreshFailed = "Не удалось обновить"
    override val refreshNextUpdate = { p0: Int -> "Следующее обновление через $p0 с" }
    override val refreshUpdating = "Обновление…"
    override val dataNone = "Данных пока нет"
    override val dataAgeJustNow = "Показаны только что полученные данные"
    override val dataAgeMinutes = { p0: Int -> "Показаны данные $p0 мин. назад" }
    override val dataAgeHours = { p0: Int -> "Показаны данные $p0 ч. назад" }
    override val dataAgeDays = { p0: Int -> "Показаны данные $p0 дн. назад" }
    override val actionOpenOperator = { p0: String -> "Открыть $p0" }
    override val watchNormal = "Следить за обычными велосипедами"
    override val watchElectric = "Следить за электровелосипедами"
    override val watchInstallNormal = "Установите приложение, чтобы следить за обычными велосипедами"
    override val watchInstallElectric = "Установите приложение, чтобы следить за электровелосипедами"
    override val watchStopNormal = "Перестать следить за обычными велосипедами"
    override val watchStopElectric = "Перестать следить за электровелосипедами"
    override val actionCheckRateBike = "Проверить / оценить"
    override val layerStations = "Станции"
    override val layerParking = "Велопарковки"
    override val mapLabelBikes = { p0: Int -> "$p0 вел." }
    override val mapLabelEbikes = { p0: Int -> "$p0 эл." }
    override val mapLabelFree = { p0: Int -> "$p0 своб." }
    override val scoreHeadline = { p0: String, p1: String -> "Велосипед $p0 · $p1" }
    override val scoreNoRatings = "Оценок пока нет — ваша будет первой."
    override val scoreLooksGood = "Выглядит хорошо."
    override val scoreHasProblems = "С этим велосипедом были проблемы."
    override val scoreMixed = "Отзывы разные."
    override val ratingNetworkRequired = "Сначала выберите сеть этого велосипеда."
    override val ratingThanks = { p0: String -> "Спасибо за оценку велосипеда $p0!" }
    override val ratingCooldown = { p0: Int -> "Вы недавно уже оценили этот велосипед. Повторите через $p0 мин." }
    override val ratingQueued = "Сохранено — отправим, когда вы снова будете в сети."
    override val ratingInvalidBike = "Этот номер велосипеда недействителен для этой сети."
    override val ratingRejected = "Не удалось сохранить оценку. Повторите попытку позже."
    override val notificationFoundTitle = "Велосипед доступен"
    override val notificationFoundNormal = { p0: String -> "Обычный велосипед доступен: $p0" }
    override val notificationFoundElectric = { p0: String -> "Электровелосипед доступен: $p0" }
    override val notificationExpiredTitle = "Слежение за станцией завершено"
    override val notificationExpiredNormal = { p0: String -> "Слежение за обычными велосипедами прекращено через 30 минут: $p0" }
    override val notificationExpiredElectric = { p0: String -> "Слежение за электровелосипедами прекращено через 30 минут: $p0" }
    override val channelWatchAlertsName = "Оповещения о станциях"
    override val channelWatchAlertsDescription = "Наличие велосипедов и новости по отслеживаемым станциям"
    override val channelBackgroundWatchName = "Слежение за станциями в фоне"
    override val notificationWatchingTitle = "Слежение за станциями"
    override val notificationWatchingText = "Отслеживаем выбранные станции в фоне"
    override val scoreFewRatings = { count: Int ->
        russianPlural(
            count,
            "Пока только $count оценка.",
            "Пока только $count оценки.",
            "Пока только $count оценок.",
        )
    }
    override val scorePositiveRides = { percent: Int, count: Int ->
        russianPlural(
            count,
            "$percent% положительных за последнюю $count поездку",
            "$percent% положительных за последние $count поездки",
            "$percent% положительных за последние $count поездок",
        )
    }
}
